import React, { useState, useEffect } from "react";
import "./style.scss";
import WarrantyList from "./WarrantyList";
import WarrantyDetail from "./WarrantyDetail";
import Storelist from "../../Store/Actions";
import Api from "../../Utils/Api";
import { toast } from "react-toastify";
import CreateRequest from "../../Components/Createrequest";
import Servicedetail from "../../Components/Servicedetail";
import { useNavigate } from "react-router-dom";

const Warranty = () => {
  const [records, setRecords] = useState([]);
  const [selectedWarranty, setSelectedWarranty] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    page: 1,
    limit: 20,
    search: "",
    status: "",
    fromDate: "",
    toDate: "",
  });
  const [totalCount, setTotalCount] = useState(0);
  const [warrantyStatuses, setWarrantyStatuses] = useState([]);

  const {
    PageStore,
    setCreatemodal_,
    clearCreateRequestData_,
    setCreateRequestData_,
    setBikelist_,
    setAddresslist_,
  } = Storelist();

  const {
    _Post_MobileNumber,
    GetStoreWarranties,
    _GetStoreWarranties,
    GetWarrantyById,
    _GetWarrantyById,
    GetWarrantyService,
    _GetWarrantyService,
    GetWarrantyStatuses,
    _GetWarrantyStatuses,
    CreateWarrantyServiceRequest,
    _CreateWarrantyServiceRequest,
  } = Api();

  // Fetch warranty list on mount
  useEffect(() => {
    fetchWarranties(filters);
    GetWarrantyStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchWarranties = (filterData = filters) => {
    setLoading(true);
    GetStoreWarranties({
      page: filterData.page,
      limit: filterData.limit,
      search: filterData.search || "",
      status: filterData.status || "",
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
    });
  };

  const handleFilterChange = (next) => {
    setFilters((prev) => {
      const updated = {
        ...prev,
        ...next,
        page: next.page !== undefined ? next.page : 1,
      };
      fetchWarranties(updated);
      return updated;
    });
  };

  // Handle warranty list response
  useEffect(() => {
    if (_GetStoreWarranties?.data !== null) {
      if (_GetStoreWarranties?.data?.status === 200) {
        const resBody = _GetStoreWarranties?.data?.body;
        let data = [];
        let total = 0;

        if (Array.isArray(resBody?.data?.data)) {
          data = resBody.data.data;
          total = resBody.data.pagination?.total ?? resBody.data.total ?? data.length;
        } else if (Array.isArray(resBody?.data)) {
          data = resBody.data;
          total = resBody.total ?? resBody.pagination?.total ?? data.length;
        } else if (Array.isArray(resBody?.data?.list)) {
          data = resBody.data.list;
          total = resBody.data.pagination?.total ?? resBody.data.total ?? data.length;
        } else if (Array.isArray(resBody?.data?.records)) {
          data = resBody.data.records;
          total = resBody.data.pagination?.total ?? resBody.data.total ?? data.length;
        }

        setRecords(data);
        setTotalCount(total);
      } else {
        setRecords([]);
        setTotalCount(0);
      }
      setLoading(false);
      _GetStoreWarranties.setData(null);
      _GetStoreWarranties.setError(null);
    } else if (_GetStoreWarranties?.error !== null) {
      setRecords([]);
      setTotalCount(0);
      setLoading(false);
      _GetStoreWarranties.setData(null);
      _GetStoreWarranties.setError(null);
    }
  }, [_GetStoreWarranties?.data, _GetStoreWarranties?.error]);

  // Handle warranty statuses response
  useEffect(() => {
    if (_GetWarrantyStatuses?.data !== null) {
      if (_GetWarrantyStatuses?.data?.status === 200) {
        const resBody = _GetWarrantyStatuses?.data?.body;
        let list = [];
        if (Array.isArray(resBody?.data?.data)) {
          list = resBody.data.data;
        } else if (Array.isArray(resBody?.data)) {
          list = resBody.data;
        }
        const statuses = list
          .map((s) => (typeof s === "string" ? s : s?.status))
          .filter(Boolean);
        setWarrantyStatuses(statuses);
      }
      _GetWarrantyStatuses.setData(null);
      _GetWarrantyStatuses.setError(null);
    }
  }, [_GetWarrantyStatuses?.data, _GetWarrantyStatuses?.error]);

  // Handle warranty detail response
  useEffect(() => {
    if (_GetWarrantyById?.data !== null) {
      if (_GetWarrantyById?.data?.status === 200) {
        const detail = _GetWarrantyById?.data?.body?.data;
        if (detail) {
          setSelectedWarranty((prev) => (prev ? { ...prev, ...detail } : detail));
          const id = detail?.id || detail?._id || detail?.warrantyId;
          if (id) {
            setLoading(true);
            GetWarrantyService(id);
          } else {
            setLoading(false);
          }
        }
      }
      _GetWarrantyById.setData(null);
      _GetWarrantyById.setError(null);
    }
  }, [_GetWarrantyById?.data]);

  // Handle free-service tracker response
  useEffect(() => {
    if (_GetWarrantyService?.data !== null) {
      if (_GetWarrantyService?.data?.status === 200) {
        setSelectedWarranty((prev) =>
          prev
            ? { ...prev, freeServices: _GetWarrantyService?.data?.body?.data }
            : prev
        );
      }
      setLoading(false);
      _GetWarrantyService.setData(null);
      _GetWarrantyService.setError(null);
    }
  }, [_GetWarrantyService?.data, _GetWarrantyService?.error]);

  // Handler to view detail
  const handleViewDetails = (warrantyItem) => {
    setSelectedWarranty(warrantyItem);
    const id =
      warrantyItem.id || warrantyItem._id || warrantyItem.warrantyId;
    if (id) {
      setLoading(true);
      GetWarrantyById(id);
    }
  };

  // Handler to go back to list
  const handleBackToList = () => {
    setSelectedWarranty(null);
  };

  // Handle create free service request response
  useEffect(() => {
    if (_CreateWarrantyServiceRequest?.data !== null) {
      if (_CreateWarrantyServiceRequest?.data?.status === 200) {
        toast.success("Service request created successfully!", {
          position: "top-center",
        });
        const id =
          selectedWarranty?.id ||
          selectedWarranty?._id ||
          selectedWarranty?.warrantyId;
        if (id) GetWarrantyService(id);
      } else {
        toast.error("Something went wrong", { position: "top-center" });
      }
      _CreateWarrantyServiceRequest.setData(null);
      _CreateWarrantyServiceRequest.setError(null);
    } else if (_CreateWarrantyServiceRequest?.error !== null) {
      toast.error(
        _CreateWarrantyServiceRequest?.error?.body?.message ||
          "Something went wrong",
        { position: "top-center" }
      );
      _CreateWarrantyServiceRequest.setData(null);
      _CreateWarrantyServiceRequest.setError(null);
    }
  }, [
    _CreateWarrantyServiceRequest?.data,
    _CreateWarrantyServiceRequest?.error,
  ]);

  // Handler when clicking "Create Request" from Free-Service Tracker
  const handleCreateRequest = (warranty) => {
    // Clear any existing request data
    clearCreateRequestData_();
    if (_Post_MobileNumber?.setData) {
      _Post_MobileNumber.setData(null);
    }

    // Resolve customer fields from warranty object
    const mobile =
      warranty.userid?.imobilenumber ||
      warranty.mobileNumber ||
      warranty.phone ||
      warranty.mobile ||
      "";
    const name =
      warranty.userid?.sfullname ||
      warranty.customerName ||
      warranty.name ||
      "";
    const email =
      warranty.userid?.emailId ||
      warranty.appLogin?.email ||
      warranty.email ||
      "";

    // Pre-populate only customer name, email and mobile number
    if (mobile) setCreateRequestData_({ key: "mobile", value: String(mobile) });
    if (name) setCreateRequestData_({ key: "name", value: name });
    if (email) setCreateRequestData_({ key: "email", value: email });

    // Store the warranty details so the Create Request panels can show
    // the warranty eligibility/tag and free-service details
    setCreateRequestData_({ key: "warrantyData", value: warranty });

    // Auto-select the warranty bicycle so it is the default chosen option
    const warrantyBike = warranty.bikeid || warranty.bicycle;
    if (warrantyBike && warrantyBike?._id) {
      setBikelist_([{ ...warrantyBike, _id: warrantyBike._id }]);
      setCreateRequestData_({ key: "bike_id", value: warrantyBike._id });
      setCreateRequestData_({
        key: "bikeType",
        value: warrantyBike?.bikeType?._id || "",
      });
      setCreateRequestData_({
        key: "gearSystem",
        value: warrantyBike?.gearSystem?._id || "",
      });
      setCreateRequestData_({
        key: "bikeBrand",
        value: warrantyBike?.brand?._id || "",
      });
      setCreateRequestData_({
        key: "bikeModel",
        value: warrantyBike?.model || warrantyBike?.modelName || "",
      });
      setCreateRequestData_({
        key: "frame_number",
        value: warrantyBike?.frameNumber || "",
      });
    } else {
      setBikelist_([]);
    }

    // Navigate back to dashboard and open Create Request modal
    navigate("/");
    setCreatemodal_(true);
  };

  return (
    <div className="warranty-container">
      {selectedWarranty ? (
        <WarrantyDetail
          warranty={selectedWarranty}
          onBack={handleBackToList}
          onCreateRequest={handleCreateRequest}
        />
      ) : (
        <WarrantyList
          records={records}
          onViewDetails={handleViewDetails}
          loading={loading}
          filters={filters}
          onFilterChange={handleFilterChange}
          totalCount={totalCount}
          statuses={warrantyStatuses}
        />
      )}

      {/* Render Create Request Modal if opened */}
      {PageStore?.is_create_modal && <CreateRequest />}
      {PageStore?.is_create_modal && <Servicedetail />}
    </div>
  );
};

export default Warranty;
